import request from '@/http/http'
const PREFIX = 'api/deer/ads';
export function getAds(query){
  return request({
    url: PREFIX ,
    params:query
  })
}
export function createAds(data){
  return request({
    url: PREFIX ,
    method: 'post',
    data: data,
    // headers: {
    //   "Content-Type": "multipart/form-data"
    // }
  })
}

// 获取广告信息
export function getAdsInfo(id){
  return request({
    url: `${PREFIX}/${id}`,
  })
}
// 修改广告信息
export function updateAdsInfo(id,formData){
  return request({
    url: `${PREFIX}/${id}`,
    method: 'put',
    data: formData,
    // headers: {
    //   "Content-Type": "multipart/form-data"
    // }
  })
}
export function deleteAds(id){
  return request({
    url: `${PREFIX}/${id}`,
    method: 'delete',
  })
}

export function updateAdsStatus(id,data){
  return request({
    url: `${PREFIX}/${id}/update-status?statusType=${data}`,
    method: 'put',
  })
}

// 获取展位信息
export function getStandList(id,query){
  return request({
    url: `${PREFIX}/place-list/${id}`,
    params:query
  })
}
// 添加展位信息
export function createStand(id,data){
  return request({
    url: `${PREFIX}/${id}/place`,
    method: 'post',
    data
  })
}
// 修改展位信息
export function updateStandInfo(id,standId,data){
  return request({
    url: `${PREFIX}/${id}/place/${standId}`,
    method: 'put',
    data
  })
}
// 修改展位状态
export function updateStandStatus(standId,status){
  return request({
    url: `${PREFIX}/place-status/${standId}?statusType=${status}`,
    method: 'put',
  })
}
// 删除展位
export function deleteStand(standId){
  return request({
    url: `${PREFIX}/place/${standId}`,
    method: 'delete',
  })
}

